module.exports = __webpack_public_path__ + "img/product-content-0.01f90386.png";